import { TFunction } from 'src/constants/i18next';
import { IUser } from 'src/interfaces/user';

/**
 * Group agents by job title
 *
 * @param {IUser[]} sources
 * @return {*}
 */
export const groupAgents = (agents: IUser[], t: TFunction) => {
    const groupedAgents = agents.reduce(
        (acc: Record<string, IUser[]>, agent) => {
            const jobTitle = agent.job || t('Jobs.NoJob');
            if (!jobTitle) return acc;
            if (!acc[jobTitle]) {
                acc[jobTitle] = [];
            }
            acc[jobTitle].push(agent);
            return acc;
        },
        {}
    );

    Object.keys(groupedAgents).forEach((job) => {
        groupedAgents[job] = groupedAgents[job].sort((a, b) =>
            a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
        );
    });

    return groupedAgents;
};
